import { render, staticRenderFns } from "./ConsultDetail.vue?vue&type=template&id=f27bcd3e&scoped=true&"
import script from "./ConsultDetail.vue?vue&type=script&lang=js&"
export * from "./ConsultDetail.vue?vue&type=script&lang=js&"
import style0 from "./ConsultDetail.vue?vue&type=style&index=0&id=f27bcd3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27bcd3e",
  null
  
)

export default component.exports